/**
 * AGNT investor email-alerts bar — global chrome that sits above the footer on
 * every AGNT page (the header's "Investor Alerts" CTA and the footer
 * "Subscribe" link both target its `#alerts` anchor, so it must exist
 * site-wide). Rendered by `AgntIncLayout` alongside the header and footer.
 *
 * Form rendering is delegated to the shared `InvestorAlertsForm` (`variant="bar"`),
 * keeping submission logic in one place for when the alerts backend is wired up.
 */

import InvestorAlertsForm from './investor-alerts-form';
import styles from './investor-alerts-bar.module.scss';

export default function InvestorAlertsBar() {
  return (
    <section className={styles.alertsBar} id="alerts">
      <div className={styles.alertsBarIn}>
        <div className={styles.alertsBarT}>Get Investor Email Alerts</div>
        <InvestorAlertsForm variant="bar" />
      </div>
    </section>
  );
}
